import { Injectable } from '@angular/core';
import { EncryptStorageNoble } from 'encrypt-storage';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    private readonly encryptLocalStorage = new EncryptStorageNoble(environment.encryptionKey, {
        prefix: 'pims',
        storageType: 'localStorage',
        encAlgorithm: 'AES-GCM',
    });

    private readonly encryptSessionStorage = new EncryptStorageNoble(environment.encryptionKey, {
        prefix: 'pims',
        storageType: 'sessionStorage',
        encAlgorithm: 'AES-GCM',
    });

    setLocalItem<T>(key: string, value: T) {
        this.encryptLocalStorage.setItem(key, value, true);
    }

    getLocalItem<T>(key: string): T | null {
        return this.encryptLocalStorage.getItem<T>(key, true) ?? null;
    }

    removeLocalItem(key: string) {
        this.encryptLocalStorage.removeItem(key);
    }

    clearLocal(): void {
        this.encryptLocalStorage.clear();
    }

    setSessionItem<T>(key: string, value: T) {
        this.encryptSessionStorage.setItem(key, value, true);
    }

    getSessionItem<T>(key: string): T | null {
        return this.encryptSessionStorage.getItem<T>(key, true) ?? null;
    }

    removeSessionItem(key: string) {
        this.encryptSessionStorage.removeItem(key);
    }

    clearSession(): void {
        this.encryptSessionStorage.clear();
    }
}
